import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, TableCell } from '@mui/material';

import { DynamicTooltip } from 'shared/ui/Tooltip';

import { getDefaultAlign } from './getDefaultAlign';

import type { ReportWidgetColumnConfig } from '../../model/types';

interface ReportWidgetTableHeaderCellProps {
    column: ReportWidgetColumnConfig;
    measuredWidth?: number;
}

export const ReportWidgetTableHeaderCell = ({
    column,
    measuredWidth,
}: ReportWidgetTableHeaderCellProps) => {
    const width = measuredWidth != null ? `${measuredWidth}px` : undefined;

    const minWidthNum = measuredWidth ?? column.minWidth;
    const minWidth = minWidthNum != null ? `${minWidthNum}px` : undefined;

    const maxWidthNum = measuredWidth ?? column.maxWidth;
    const maxWidth = maxWidthNum != null ? `${maxWidthNum}px` : undefined;

    return (
        <TableCell
            key={column.id}
            align={getDefaultAlign(column)}
            sx={{
                fontWeight: 500,
                color: 'text.secondary',
                width,
                minWidth,
                maxWidth,
                whiteSpace: 'nowrap',
            }}
        >
            <Box
                sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 0.5,
                }}
            >
                {column.label}
                {column.headerTooltip && (
                    <DynamicTooltip
                        content={column.headerTooltip}
                        containerStyle={{
                            paddingTop: '4px',
                        }}
                    >
                        <InfoOutlinedIcon
                            sx={{
                                fontSize: '14px',
                            }}
                            data-pdf-tooltip="true"
                        />
                    </DynamicTooltip>
                )}
            </Box>
        </TableCell>
    );
};
